import { RouteRecordRaw } from 'vue-router';

export const support: Array<RouteRecordRaw> = [
    
    {path: '/support', name: 'support', component: () => import('@/page/support/index.vue'),
        children:[],
    },
    
  
]